import { BuildTags } from '@onshape/www-inertia';
type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'HEAD' | 'OPTIONS';

export function useWwwFetch<RespT>({
  url,
  method,
  headers,
  body,
}: {
  url: URL;
  method: HttpMethod;
  headers?: Record<string, string>;
  body?: JsonBlob;
}) {
  const data = $fetch<RespT>(url.toString(), {
    method: method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-www-referer': document.location.href,
      'x-www-build-tags': `www ${BuildTags.packageVersion} ${BuildTags.buildHash} ${new Date(BuildTags.buildTime).getTime() / 1000}`,
      ...headers,
    },
    body: body ?? undefined,
  });

  return data;
}
